import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, Tag } from 'lucide-react';
import { Card, CardContent, CardHeader, CardFooter } from './Card';
import { Button } from './Button';
interface WorkshopCardProps {
  id: string;
  title: string;
  date: string;
  time: string;
  theme: string;
  imageUrl?: string;
  volzet?: boolean;
  type?: 'workshop' | 'maekerscafe';
}
export function WorkshopCard({
  id,
  title,
  date,
  time,
  theme,
  imageUrl,
  volzet = false,
  type = 'workshop'
}: WorkshopCardProps) {
  return <Card variant="outlined" isClickable data-id="element-266">
      <CardContent className="flex flex-col h-full" data-id="element-267">
        <div className="relative border-2 border-dashed border-gray-300 h-40 flex items-center justify-center bg-gray-100 overflow-hidden" data-id="element-268">
          {imageUrl ? <img src={imageUrl} alt={title} className="w-full h-full object-cover" data-id="element-269" /> : <span className="text-gray-400" data-id="element-270">Workshop afbeelding</span>}
          {volzet && <span className="absolute top-2 right-2 bg-gray-800 text-white text-xs font-medium px-2 py-0.5 rounded" data-id="element-271">
              VOLZET
            </span>}
        </div>
        <CardHeader title={title} className="mt-3 mb-2" data-id="element-272" />
        <div className="space-y-2 text-sm text-gray-600 flex-grow" data-id="element-273">
          <div className="flex items-center" data-id="element-274">
            <Calendar size={16} className="mr-2 flex-shrink-0" data-id="element-275" />
            <span className="truncate" data-id="element-276">{date}</span>
          </div>
          <div className="flex items-center" data-id="element-277">
            <Clock size={16} className="mr-2 flex-shrink-0" data-id="element-278" />
            <span className="truncate" data-id="element-279">{time}</span>
          </div>
          <div className="flex items-center" data-id="element-280">
            <Tag size={16} className="mr-2 flex-shrink-0" data-id="element-281" />
            <span className="truncate" data-id="element-282">{theme}</span>
          </div>
        </div>
        <CardFooter className="mt-4 pt-3 border-t border-gray-200" data-id="element-283">
          <Link to={type === 'maekerscafe' ? `/maekerscafés/${id}` : `/workshops/${id}`} className="w-full" data-id="element-284">
            <Button variant="secondary" size="medium" className="w-full" data-id="element-285">
              {type === 'maekerscafe' ? 'Bekijk maekerscafé' : 'Bekijk workshop'}
            </Button>
          </Link>
        </CardFooter>
      </CardContent>
    </Card>;
}